import { render, staticRenderFns } from "./DebtorGroupInfo.vue?vue&type=template&id=a2272754&scoped=true"
import script from "./DebtorGroupInfo.vue?vue&type=script&lang=ts"
export * from "./DebtorGroupInfo.vue?vue&type=script&lang=ts"
import style0 from "./DebtorGroupInfo.vue?vue&type=style&index=0&id=a2272754&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2272754",
  null
  
)

export default component.exports